import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function WaterForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount) return;

    onAdd({
      date: new Date(date).toISOString(),
      amount: amount,
      notes: notes,
    });

    setDate(toDatetimeLocal());
    setAmount("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Amount (oz)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 2"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            step="0.5"
            min="0"
          />
        </div>
        <div className="col-md-4 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add Water
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <label htmlFor="waterNotesInput" className="form-label">Notes (optional)</label>
          <input
            id="waterNotesInput"
            type="text"
            className="form-control"
            placeholder="e.g. refused bottle, very thirsty after bath"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>
    </form>
  );
}
